import { useSelector, shallowEqual } from "react-redux";
import MerchandisingMediasIntro from "app/pages/Merchandising/Media/MerchandisingMediasIntro";
import { getMerchandisingDescription } from "app/pages/Merchandising/merchandisingSelector";

const mapStateToProps = state => {
	const currentMerchandising = state.merchandising.current;

	return {
		mediaIntroduction: getMerchandisingDescription(state),
		fromPrice: currentMerchandising?.lowestPrice,
	};
};

const MerchandisingMediasIntroContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	return <MerchandisingMediasIntro {...props} {...stateProps} />;
};

export default MerchandisingMediasIntroContainer;
